export * from './IconScreenFilled';
